import { ResourcePermissions } from '@repo/api-client';
import IconClock from '@repo/ui-icons/IconClock';
import IconDocumentCopy from '@repo/ui-icons/IconDocumentCopy';
import IconGift from '@repo/ui-icons/IconGift';
import IconHome from '@repo/ui-icons/IconHome';
import IconNewsfeed from '@repo/ui-icons/IconNewsfeed';
import IconPen from '@repo/ui-icons/IconPen';
import IconProject from '@repo/ui-icons/IconProject';
import IconSettings from '@repo/ui-icons/IconSettings';
import IconTemplates from '@repo/ui-icons/IconTemplates';
import IconUser from '@repo/ui-icons/IconUser';

import { NavigationMenuItemProps } from './NavigationMenuItem';

export const globalMenuItems: NavigationMenuItemProps[] = [
  {
    label: 'Home',
    href: '/',
    icon: IconHome,
    requiredPermission: ResourcePermissions.DESIGN_VIEW,
  },
  {
    label: 'Recents',
    href: '/user/dashboard/recent',
    icon: IconClock,
  },
  {
    label: 'Shared Projects',
    href: '/user/dashboard/shared',
    icon: IconDocumentCopy,
    requiredPermission: ResourcePermissions.DESIGN_VIEW,
  },
];

// TODO: these are temporary hrefs
export const getWorkspaceMenuItems = (
  showGlobalMenuItems: boolean
): NavigationMenuItemProps[] => [
  ...(showGlobalMenuItems
    ? []
    : [
        {
          label: 'Home',
          href: '/',
          icon: IconHome,
          hrefPrefixedByWorkspace: true,
          requiredPermission: ResourcePermissions.DESIGN_VIEW,
        },
      ]),
  {
    label: 'Projects',
    icon: IconProject,
    hrefPrefixedByWorkspace: true,
    href: '/projects',
    requiredPermission: ResourcePermissions.DESIGN_VIEW,

    activeUrls: ['/user/dashboard'],
    items: [
      ...(showGlobalMenuItems
        ? []
        : [
            {
              label: 'Shared Projects',
              href: '/user/dashboard/shared',
              requiredPermission: ResourcePermissions.DESIGN_EDIT,
            },
          ]),
      {
        label: 'Trash',
        requiredPermission: ResourcePermissions.DESIGN_EDIT,
        href: '/projects/trash',
        hrefPrefixedByWorkspace: true,
        activeUrls: [
          '/user/dashboard/trash',
          /workspace\/[^/]+\/projects\/trash/,
        ],
      },
    ],
  },
  {
    label: 'Templates',
    requiredPermission: ResourcePermissions.DESIGN_EDIT,
    icon: IconTemplates,
    href: '/templates',
    items: [
      {
        label: 'Bookmarks',
        href: '/user/dashboard/bookmarked',
        requiredPermission: ResourcePermissions.DESIGN_EDIT,
      },
    ],
    activeUrls: [/^\/templates\/[^/]+$/],
  },
  {
    label: 'Tools',
    requiredPermission: ResourcePermissions.DESIGN_EDIT,
    href: '/user/dashboard/tools',
    icon: IconPen,
  },
];

const communityMenuItems: NavigationMenuItemProps[] = [
  {
    label: 'Profile',
    href: '/profile',
    icon: IconUser,
    requiredPermission: ResourcePermissions.DESIGN_VIEW,
  },
  {
    label: 'Blog',
    href: '/blog',
    icon: IconNewsfeed,
    activeUrls: ['/blog', /^\/article\/[^/]+$/],
    requiredPermission: ResourcePermissions.ASSET_VIEW,
  },
];

const moreMenuItems: NavigationMenuItemProps[] = [
  {
    label: 'Settings',
    href: '/user/settings/account',
    requiredPermission: ResourcePermissions.DESIGN_EDIT,
    icon: IconSettings,
    activeUrls: [
      '/user/settings/account',
      '/user/settings/password',
      '/user/settings/email-preferences',
      '/user/settings/subscription',
      '/user/settings/team-members',
    ],
  },
  {
    label: 'Earn Rewards',
    href: '/user/settings/referral',
    icon: IconGift,
    activeUrls: ['/user/settings/referral', '/earn'],
    requiredPermission: ResourcePermissions.DESIGN_EDIT,
  },
];

export const getMainNavigationMenu = (
  showGlobalMenuItems: boolean,
  workspacesEnabled: boolean
): {
  title?: string;
  requiredPermission: ResourcePermissions;
  items: NavigationMenuItemProps[];
}[] => [
  {
    requiredPermission: ResourcePermissions.DESIGN_VIEW,
    items: getWorkspaceMenuItems(showGlobalMenuItems),
  },
  {
    requiredPermission: ResourcePermissions.DESIGN_VIEW,
    title: 'Community',
    items: communityMenuItems,
  },
  ...(!workspacesEnabled
    ? [
        {
          requiredPermission: ResourcePermissions.DESIGN_EDIT,
          title: 'More',
          items: moreMenuItems,
        },
      ]
    : []),
];
